import { Order } from '@components/account/types'

export function calculateOrderSubtotal(
  order: Order,
  totalDiscount: number,
  discountType: string
): number {
  if (!order || !order.discountApplications) {
    return Number(order.subtotal?.amount) || 0
  }

  // Check if there's an order-wide percentage based discount
  const hasPercentageDiscount = order.discountApplications.some(
    discount =>
      discount.allocationMethod === 'ACROSS' &&
      discount.targetSelection === 'ALL' &&
      discount.value?.percentage
  )
  // Check if there's an order-wide fixed amount based discount
  const hasFixedAmountDiscount = order.discountApplications.some(
    discount =>
      discount.allocationMethod === 'ACROSS' &&
      discount.targetSelection === 'ALL' &&
      discount.value?.amount
  )

  let subtotal = Number(order.subtotal?.amount) || 0

  // If an order-wide discount is applied, sum up original line item prices
  if (hasPercentageDiscount || hasFixedAmountDiscount) {
    subtotal = order.lineItems.reduce(
      (sum, item) => sum + Number(item.price.amount),
      0
    )
  }

  // Add tax if no order-wide discount is applied
  if (!hasPercentageDiscount && !hasFixedAmountDiscount) {
    subtotal += Number(order.totalTax?.amount) || 0
  }

  // If an order-wide percentage discount exists, add back the discount amount
  if (discountType === 'AMOUNT' && hasPercentageDiscount) {
    subtotal += totalDiscount
  }

  return subtotal
}
